__turbopack_context__.v({
  "Body": "ZiyUnG_Body",
  "Highlights": "ZiyUnG_Highlights",
  "HighlightsWrapper": "ZiyUnG_HighlightsWrapper",
  "RichTextHighlightsSection": "ZiyUnG_RichTextHighlightsSection",
  "custom": "ZiyUnG_custom",
  "custom-2": "ZiyUnG_custom-2",
  "double": "ZiyUnG_double",
  "type-sidelines": "ZiyUnG_type-sidelines",
  "type-sidelines-dotted": "ZiyUnG_type-sidelines-dotted",
});
